import { tns } from 'tiny-slider/src/tiny-slider'

const ProjectsSlider = () => {
  const sliders = document.querySelectorAll('.js-projects-slider')

  if (!sliders) {
    return
  }

  ;[...sliders].forEach(slider => {

    let edgepadding = 25
    if (document.body.clientWidth > 1600) {
      edgepadding = 0
    }

    const activeSlider = tns({
      container: slider,
      responsive: {
        '0': 1,
        '640': 2,
        '1000': 3,
      },
      slideBy: 1,
      autoplay: false,
      nav: false,
      edgePadding: edgepadding,
      gutter: 15,
      controls: false,
      mouseDrag: true,
      touch: true
    })

    const navigators = document.querySelectorAll('.js-nav')
    ;[...navigators].forEach(nav => {
      const direction = nav.dataset.direction
      nav.addEventListener('click', e => {
        if (direction === 'prev') {
          activeSlider.goTo('prev')
        } else {
          activeSlider.goTo('next')
        }
      })
    })

  }) //end foreach

}

export default ProjectsSlider



// WEBPACK FOOTER //
// ./src/js/modules/ProjectsSlider.js